module.exports = __webpack_public_path__ + "img/135x90-03.ff44f744.png";